const initialState = {
    value: 'gl'
}

export const selectedMetodePembayaranCorporate = (state = initialState, actions) => {
    if (actions.type === 'SET_METODE_PEMBAYARAN_CORPORATE') {
        return {
            ...state,
            value: actions.value
        }
    }
    return state
}